export const isPerformanceAPISupported =
  typeof performance !== 'undefined' &&
  typeof performance.mark === 'function' &&
  typeof performance.measure === 'function' &&
  typeof performance.getEntriesByName === 'function';

// Align with Web Vitals
// https://github.com/GoogleChrome/web-vitals/blob/1b872cf5f2159e8ace0e98d55d8eb54fb09adfbe/src/onLCP.ts#L74
export const navStart = isPerformanceAPISupported
  ? performance.getEntriesByType('navigation')[0]?.activationStart || 0
  : 0;
export const timeOrigin = isPerformanceAPISupported ? performance.timeOrigin : Date.now();
